var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_2637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_2637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.25 35.6875L40.1875 32.625C41.1042 31.5417 41.8021 30.3542 42.2813 29.0625C42.7604 27.7708 43 26.4167 43 25C43 23.3333 42.6667 21.75 42 20.25C41.3333 18.75 40.4167 17.4167 39.25 16.25L42.25 13.25C43.8333 14.8333 45.0625 16.625 45.9375 18.625C46.8125 20.625 47.25 22.75 47.25 25C47.25 27 46.8958 28.9063 46.1875 30.7188C45.4792 32.5313 44.5 34.1875 43.25 35.6875ZM35.8125 28.25L27.25 19.6875C27.75 19.3958 28.2708 19.1667 28.8125 19C29.3542 18.8333 29.9167 18.75 30.5 18.75C32.25 18.75 33.7292 19.3542 34.9375 20.5625C36.1458 21.7708 36.75 23.25 36.75 25C36.75 25.5833 36.6667 26.1458 36.5 26.6875C36.3333 27.2292 36.1042 27.75 35.8125 28.25ZM49.25 41.625L46.25 38.625C47.9167 36.75 49.1667 34.6354 50 32.2813C50.8333 29.9271 51.25 27.5 51.25 25C51.25 22.25 50.7396 19.5938 49.7188 17.0313C48.6979 14.4688 47.2083 12.2083 45.25 10.25L48.25 7.25C50.5417 9.66667 52.3229 12.3958 53.5938 15.4375C54.8646 18.4792 55.5 21.6667 55.5 25C55.5 28.0833 54.9688 31.0521 53.9063 33.9063C52.8438 36.7604 51.2917 39.3333 49.25 41.625ZM49.9375 56.5L33 39.5625V52.5H28V34.5625L18 24.625V25C18 26.6667 18.3333 28.25 19 29.75C19.6667 31.25 20.5833 32.5833 21.75 33.75L18.75 36.75C17.1667 35.1667 15.9375 33.375 15.0625 31.375C14.1875 29.375 13.75 27.25 13.75 25C13.75 24.2917 13.7917 23.6042 13.875 22.9375C13.9583 22.2708 14.1042 21.5833 14.3125 20.875L11.125 17.6875C10.6667 18.8958 10.3229 20.1042 10.0938 21.3125C9.86458 22.5208 9.75 23.75 9.75 25C9.75 27.75 10.2604 30.4063 11.2813 32.9688C12.3021 35.5313 13.7917 37.7917 15.75 39.75L12.75 42.75C10.4583 40.3333 8.67708 37.6042 7.40625 34.5625C6.13542 31.5208 5.5 28.3333 5.5 25C5.5 23.1667 5.69792 21.3646 6.09375 19.5938C6.48958 17.8229 7.08333 16.1042 7.875 14.4375L4 10.5625L7.5 7L53.5 53L49.9375 56.5Z",
    fill: "#5776E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalDisconnected);
export default __webpack_public_path__ + "static/media/signal_disconnected.9d51004a947f1e26f43ea392ed9221eb.svg";
export { ForwardRef as ReactComponent };